import script from "./CoreUiChatHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistory.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistory.vue?vue&type=style&index=0&id=551e4bf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-551e4bf8"]])

export default __exports__